export default {
  table: {
    data: [],
    loading: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: 'name',
      totalItems: 0,
      rowsPerPageItems: [5, 10, 15, 20],
      search: '',
    },
  },
  specifiedGroup: {
    products: [],
    loading: true,
  },
  products: {
    data: [],
    loading: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: 'name',
      totalItems: 0,
      rowsPerPageItems: [5, 10, 15, 20],
      search: '',
    },
  },
  allGroupsTable: {
    loading: false,
    data: [],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: 'name',
      totalItems: 0,
      rowsPerPageItems: [5, 10, 15, 20],
      search: '',
    },
  },
};
